export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden opacity-20">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-500/15 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-accent-500/10 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 lg:px-8 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-flashlight-line text-primary-500 text-xs"></i>
              </span>
              <span className="text-xs md:text-sm text-primary-400 font-medium whitespace-nowrap">
                每日更新 · 极速播放 · 高清画质
              </span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight tracking-tight">
              天天影院
              <span className="block text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-foreground-600 font-normal mt-2">
                海量高清电影免费在线观看平台
              </span>
            </h1>

            <p className="font-heading italic text-lg md:text-xl text-primary-500 mt-3 mb-6">
              最新最全的电影大全，随时随地畅享观影体验
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              天天影院汇聚最新电影大全、动作片在线、喜剧片免费看、科幻片高清播放及经典电影全集，
              覆盖动作、喜剧、科幻、悬疑、爱情、动画等全类型片库。每日同步更新院线新片与网络热映资源，
              极速播放不卡顿，高清画质免费看，是您身边最值得信赖的在线观影平台。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                  10万<span className="text-primary-500">+</span>
                </div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">电影资源</div>
              </div>
              <div className="w-px h-10 bg-background-300/50"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                  每日<span className="text-primary-500">30+</span>
                </div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">部新片上线</div>
              </div>
              <div className="w-px h-10 bg-background-300/50"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                  高清<span className="text-accent-500">无广告</span>
                </div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">极速畅享</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                onClick={(e) => handleClick(e, '#carousel')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-md transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <span className="w-4 h-4 inline-flex items-center justify-center mr-2">
                  <i className="ri-play-circle-line"></i>
                </span>
                开始观影
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleClick(e, '#ranking')}
                className="w-full sm:w-auto px-8 py-3 border border-foreground-300/40 hover:border-primary-500/50 text-foreground-700 hover:text-primary-500 rounded-md transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <span className="w-4 h-4 inline-flex items-center justify-center mr-2">
                  <i className="ri-bar-chart-line"></i>
                </span>
                查看热播榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/5 rounded-2xl blur-xl"></div>
              <div className="relative rounded-xl overflow-hidden border border-background-200/60 bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20aesthetic%20with%20warm%20golden%20ambient%20lighting%20and%20film%20reel%20elements%2C%20luxurious%20velvet%20curtains%20in%20deep%20crimson%20tones%2C%20dramatic%20spotlight%20illuminating%20a%20classic%20movie%20clapperboard%2C%20elegant%20art%20deco%20details%2C%20rich%20dark%20atmosphere%20with%20golden%20accents%2C%20premium%20cinema%20visual%20identity&width=1200&height=800&seq=hero-cinema-2026&orientation=landscape"
                  alt="天天影院 · 海量高清电影免费在线观看平台"
                  className="w-full h-auto object-cover"
                  width="1200"
                  height="800"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/70 via-transparent to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}